import React from 'react';
import { useHistory } from 'react-router-dom';
import { EditOutlined } from '@mui/icons-material';
import style from '../style';

const { HeaderEditButton } = style;

/**
 * @typedef {Object} Props
 * @property {boolean} [visible=false] - Parametro para indicar si se muestra el botón o no.
 * @property {string} courseId - ID del curso a editar.
 */

/**
 * Botón de edición de curso, solo se muestra si el curso es visto por el mismo usuario que lo creó.
 * @param {Props} props - Propiedades del componente.
 */
const CourseEditButton = ({ visible = false, courseId }) => {
  const history = useHistory();

  if (visible === false || !courseId) return null;

  return (
    <HeaderEditButton
      onClick={() => {
        history.push({
          pathname: `/cursos/${courseId}/editar`,
          state: { isComingFrom: 'detalles' },
        });
      }}
    >
      <EditOutlined />
    </HeaderEditButton>
  );
};

export default CourseEditButton;
